import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../globals';

import { FirestoreService } from './firestore/firestore.service';
import { Upload } from './upload/upload';
import * as firebase from 'firebase';
import { ActivityClassificationId } from './activity-classification.service';

export var PdfActivityDisplayLabels = {
	key1: 'VoBo Calidad',
	key2: 'VoBo Producción',
	key3: 'Pre-Prensa',
}

export interface Activity {
	active: number;
	activityClassificationRef: any;
	isGeneral: boolean;
	quantityPricesFunction: string;
	activityValue: number;
	createdAt: any;
	dataCalc: number;
	measurementUnitRef: any;
	name: string;
	ranges?: any;
	prices: number[];
	updatedAt: any;
	value: number;
	appliesPrVnta: boolean;
	appliesOdP: boolean;
	unique: any;
	minPrice: number;
	fileURL: string;

	pdfDisplay?: { [key in keyof typeof PdfActivityDisplayLabels]: boolean };
}

export interface ActivityId extends Activity {
	  id: string;
	  activityClassObj: ActivityClassificationId;
	  classification: string;
}

@Injectable()
export class ActivityService {

	activityCollection: AngularFirestoreCollection<Activity>;
	activities: any;

	activityDocument: AngularFirestoreDocument<ActivityId>;
	activity: Observable<ActivityId>;

	collection: string;
	activityClassCollection: string;
	measurementUnitCollection: string;

	get defaultDisplay(): ActivityId['pdfDisplay']{ return {key1: false, key2: false, key3: false} }

	constructor(
		private afs: AngularFirestore,
		private afh: FirestoreService
	) {
		this.collection = Globals.ACTIVITY_COLLECTION;
		this.measurementUnitCollection = Globals.UNIT_COLLECTION;
		this.activityClassCollection = Globals.ACTIVITY_CLASSIFICATION_COLLECTION;
	}
	/**
	 * Get all activities
	 * @return {Observable} Array of activities and their classification
	 */
	getActivities({onEmpty=undefined}={}) {
		return this.afh.colWithIds$(this.collection, ref => ref.where('active', '==', true) ).map(documents => {
      if(!documents.length && onEmpty) onEmpty();
      return documents.map(document => {
        const activityClassRef = this.afh.docWithIds$(`${document.activityClassificationRef.path}`);
        return Observable.combineLatest(
          activityClassRef,
          (activityClassData) => {
            return {
              activityClass: activityClassData
            };
        })
        .map(data => {
          return {
            activityClassObj: data.activityClass,
            ...document
          };
        });
      });
    }).mergeMap(activitiesDocuments => Observable.combineLatest(activitiesDocuments));
	}

	/**
	 * Get activity with references
   * @param {id} string id of the activity
	 * @return {Observable} of activity
	 */
	getActivity(id: string) {
		let activityDocument = this.afs.doc(this.collection + '/' + id);
		let activity = activityDocument.valueChanges();
		return activity.map(object => object);
	}

  /**
   * Add a new activity
   * @param {Activity} activity - The data of the activity
   */
	addActivity(activity: Activity) {
		function then(id){ console.log('uploaded activity ' + id); }
		if(activity.measurementUnitRef) activity.measurementUnitRef = this.afh.doc(`${this.measurementUnitCollection}/${activity.measurementUnitRef}`).ref;
		activity.activityClassificationRef = this.afh.doc(`${this.activityClassCollection}/${activity.activityClassificationRef}`).ref;
		this.afh.add(`${this.collection}`, activity, then);
	}

  /**
   * Update an existing activity
   * @param {string} id - The data of the activity
   * @param {Activity} activity - The new data for the activity
   */
	updateActivity(id: string, {...activity}: Activity) {
		if(activity.measurementUnitRef) activity.measurementUnitRef = this.afh.doc(`${this.measurementUnitCollection}/${activity.measurementUnitRef}`).ref;
		activity.activityClassificationRef = this.afh.doc(`${this.activityClassCollection}/${activity.activityClassificationRef}`).ref;
		this.afh.update(`${this.collection}/${id}`, activity);
	}

  /**
   * Update an existing activity's prices of paper
   * @param {string} prCmpaId - The prCmpa that is updating
   * @param {number} price - The new price for the activity
   */
	updatePaperPriceByPrCmpaId(prCmpaId: string, price: number) {
		let actSub = this.getActivities().subscribe(unfilteredActivities => {
			actSub.unsubscribe();
			let activities = unfilteredActivities.filter(({quantityPricesFunction: qpf}) => qpf == 'papel').filter(({unique=<any>{}}) => unique.prCmpaId == prCmpaId);
			activities.map(activity => {
				this.afh.update(`${this.collection}/${activity.id}`, {prices: [price]} as Activity);
			});
		});
	}

  /**
   * Delete an activity
   * @param {string} id - The id of the activity
   */
	deleteActivity(id: string) {
		this.afh.delete(`${this.collection}/${id}`);
	}
	

	uploadPdfFile(upload: Upload, id: string) {
		const storageRef = firebase.storage().ref();
		const uploadTask = storageRef.child(`${this.collection}/_pdfImgs/${id}_${upload.file.name}`).put(upload.file);
		uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, (snapshot: any) => {
			upload.progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
		}, (err) => {
			console.log('error al subir');
		}, () => {
			let fileURL = uploadTask.snapshot.downloadURL;
			this.afh.update(`${this.collection}/${id}`, {fileURL});
		});
	}
	deletePdfFile(id: string){
		const storageRef = firebase.storage().ref();
		var imageToDeleteRef = storageRef.child(`${this.collection}/_pdfImgs/${id}`);
		this.afh.update(`${this.collection}/${id}`, {fileURL: ''});
		imageToDeleteRef.delete();
	}

}
